@for (error of errors; track error) {
    <div>
        {{ customMessage ? customMessage : error }}
    </div>
}
